<div class="modalMain">
    <header class="modalTitle">
        <span class="h2">Define <b>Eboiler</b></span>
    </header>
    <div class="modalBody">
        <div class="eboiler-form">
            <div class="form-group">
              <label for="name">NAME</label>
              <input id="name" class="form-control" type="text" [(ngModel)]="boilerName">
            </div>

            <!-- <div class="form-group">
              <label for="name">Serial Number</label>
              <input id="name" class="form-control" type="text">
            </div>
             -->
            <div class="form-group">
              <label for="name">Gateway Address</label>
              <select id="gateway" [(ngModel)]="selectedgateway" class="form-control" #selectGateway (change)="onGatewayChange($event)">
                <option *ngFor="let gateway of gatewayAddressesList" [value]="gateway.mac_address" >{{ gateway.mac_address }}</option>
              </select>
            </div>
            
            <div class="form-group">
              <label for="name">Serial Number</label>
              <input id="name" class="form-control" type="text" [(ngModel)]="newgenericSerialNo" disabled>
            </div>

            <div class="form-group">
              <label for="site">SITE</label>
              <select id="site" [(ngModel)]="selectedSite" class="form-control" #mySelect (change)="onSiteSelected(mySelect.value)">
                <option *ngFor="let site of sitesList" [value]="site.id">{{ site.name }}</option>
              </select>
            </div>
          
            <div class="form-group">
              <label for="application">APPLICATION</label>
              <select id="application" [(ngModel)]="selectedApplication" class="form-control">
                <option *ngFor="let application of applicationList" [value]="application.id">{{ application.name }}</option>
              </select>
            </div>
            
            <div class="form-buttons">
              <button class="btn btn-primary" [disabled]="!isFormValid()" (click)="addSubsystemFun()">Continue</button>
              <button class="btn btn-secondary" (click)="onClose()">Close</button>
            </div>
          </div>
    </div>
</div>
